module.exports = __webpack_public_path__ + "img/polvo sobres.d6562a74.png";